import c from 'state/constants'
import i18n from 'lib/i18n'
import {getPromiseForTranslations} from 'lib/i18n'
import nesProp from 'nested-property'
import uuidv4 from 'uuid/v4';
import {setVersionCheckNotification} from 'state/actions'
import {AgentAppVersion} from '../../components/environments.coffee'

const translate = i18n('')

const STALE_TIME = 1 * 1000
const cache = {}

export const showLoader = (path) => ({type: c.SHOW_LOADER, path})

export const hideLoader = (path) => ({type: c.HIDE_LOADER, path})

/**
 * TAKE care because this function will overwrite the accumulated value for determine the spinner status.
 * @param {*} loaderValue
 * @returns
 */
export const forceSetLoader = (loaderValue) => ({type: c.FORCE_SET_LOADER, loaderValue})

export const hasErrors = (id) => ({type: c.HAS_ERRORS, id})

export const badCreds = () => ({type: c.BAD_CREDENTIALS})

export const apiCallReal = async (path, dispatch, options = {}) => {

	const {lang, noCache, noLoader} = options
	let {data, method, queueTransactionId} = options

    if (queueTransactionId) {
        nesProp.set(data, "queueTransactionId", queueTransactionId)
    }

	const canCache = !noCache && !data && (!method || method === 'GET')
	if (lang) {
		data = data ? {...data, lang} : {lang}
	}
	if (!method) {
		method = data ? 'POST' : 'GET'
	}
	const showSpinner = !noLoader
	const key = canCache && `${path}?${lang}`

	if (key && cache[key]) {return cache[key]}

	if (showSpinner) {
		dispatch(showLoader(path))
	}

	let headers = {
		'accept': 'application/json',
		'content-type': 'application/json',
		// second part of the CSRF token will be sent in translation, do if request is to get
		// the translations, we have no i18n initialized yet
		// also we don't need to send CSRF tokens with the GET request

        // 'keep-alive': 'timeout=5, max=100000'
	}

	if ('GET'===method || '/translations' === path) {
		// no CSRF token for translations and for get requests
	} else {
		let ret = await getPromiseForTranslations()
		headers['x-csrf-token'] = translate('csrfclienttoken')
	}

    // send to the server the curent app version
    headers['x-agent-app-version'] = AgentAppVersion

	const myInit = {
		method,
		body: data && JSON.stringify(data),
		credentials: 'include',
		headers,
        mode: 'cors',
	}

	let resP = fetch(path, myInit)
	.then(async r => {

        let newAppVersion = r.headers.get("x-agent-app-version")

        // check the Agent app build version validity, the loaded version is deprecated the show a notification
        if (newAppVersion && newAppVersion !== AgentAppVersion) {
            try{
                let textOfModal = translate("invalidAgentAppVersionDesc")
                textOfModal = textOfModal.replace("{{oldVersion}}", AgentAppVersion)
                textOfModal = textOfModal.replace("{{newVersion}}", newAppVersion)

                dispatch(setVersionCheckNotification(true, translate("invalidAgentAppVersionTitle"), textOfModal))

            } catch(error) {
                console.log(error)
                console.log("version mismatch")
            }
        }

        if (!r.ok) {return Promise.reject(r)}

        let resultJson = await r.json()

        return resultJson
    })
	.catch(async err => {
		if ((err && err.status === 401) || (err && err.status === 403)) {
			dispatch(badCreds())
		} else if (err && err.status >= 500) {
			dispatch(hasErrors('connection'))
		}

        let resultJson = await err.json()
		return Promise.reject(resultJson)
	})
	.then(r => {
		if (r.error) {
			// For now, assume all api errors are server errors
			dispatch(hasErrors('connection'))
			return Promise.reject(r)
		}
		if (r.success != null) {
			return r.success
		}
		// Old-style API
		return r
	})

	if (key) {
		// clear cache entry after STALE_TIME
		resP = resP
		.then(
			res => {
				setTimeout(() => {delete cache[key]}, STALE_TIME)
				return res
			},
			err => {
				setTimeout(() => {delete cache[key]}, STALE_TIME / 3)
				return Promise.reject(err)
			}
		)
		cache[key] = resP
	}

	// Hide loader in parallel to other callbacks
	if (showSpinner) {
		const hide = (resultOfCall) => {
            dispatch(hideLoader(path))
            return resultOfCall
        }

        const hideErr = (resultOfCall) => {
            dispatch(hideLoader(path))
            return Promise.reject(resultOfCall)
        }

		resP.then(hide, hideErr)
	}

	return resP
}

// TODO make this middleware
export const apiCall = (path, options) => dispatch => apiCallReal(path, dispatch, options)

// constant for the multi step transactional call
const API_TRANSACTION_STATUS_WAIT = "wait"
const API_TRANSACTION_STATUS_ERROR = "error"
const API_TRANSACTION_STATUS_DONE = "done"
const API_TRANSACTION_CHECK_INTERVAL_SEC = 2
const API_TRANSACTION_PATIENCE_DURATION_SEC = 80 // do call the server if this time elapse, no hope to get response

/**
 * Wrapper for apiCall what extend the calling by transactionId and make possible longer calls. Avoid response cut out.
 * This Function call more api calls then one. Expensive to use but sometimes necessary.
 * @param {string} uri path of API request
 * @param {object} requestParameters parameters for api request
 */
 export const transactionCall = (uri, requestParameters = {}) => dispatch => {
    // prepare transaction
    let queueTransactionId = uuidv4()

    // set for apiCall parameters the transactionId
    nesProp.set(requestParameters, "queueTransactionId", queueTransactionId)

    // the following piece of code can help to test session management.
    /*  let inceaseTEst = 0
    let testerId = setInterval(() => {
        dispatch(apiCall('data/increaseSessionCounter', {noCache: true, noLoader: true}))
        inceaseTEst++
        if (inceaseTEst>100) {
            clearInterval(testerId)
        }
        console.log("inceaseTEst", inceaseTEst)
    }, 500) */

    // create a promise for starting the calls, this will be resolved only when we the final response arrived
    // even if that is an error. In case of simple API response, without the multi step functionality,
    // this promise give a normal/regular response. On short responses also give immediate response.
    let transactionPromise = new Promise((resolveTransaction, rejectTransaction) => {
        // show spiner
        dispatch(showLoader(uri))

        // in case when the server never will return a response
        setTimeout(() => {
            // clear timer for rechecking
            clearInterval(timerIdForCheckResponse)
            timerIdForCheckResponse = false

            return rejectTransaction({error: translate("serverTimeoutStopLoading") + " Transaction ID: " + queueTransactionId})
        }, API_TRANSACTION_PATIENCE_DURATION_SEC * 1000)

        // create timer, to call the API call periodically in case when necessary
        // the instant response kill it immediately and return with the result
        let timerIdForCheckResponse = setInterval(() => {

            // when the timer was disabled but somehow this method was started again skip it
            if (!timerIdForCheckResponse) {
                return
            }

            // Use a normal call and check the response. If the response contains the transaction specific
            // arguments, that means the server-side data provider is upgraded and ready for fetch by multi-steps,
            // else handle the request like a normal/regular API response.
            return dispatch(apiCall(uri, requestParameters))

            // expected response data structure:
            // {status: <string>, data: <any - the expected form/hierarchy of the regular response>}
            .then((response) => {

                // when the timer was disabled but somehow this method was started again skip it
                if (!timerIdForCheckResponse) {
                    return
                }

                // try to get the queueTransactionStatus if exist, if not then process like a normal API call response
                let queueTransactionStatus = nesProp.get(response, "queueTransactionStatus")
                // this argument will be set by server in case of http error
                let queueError = nesProp.get(response, "error")

                // in case of general http error
                if (!queueTransactionStatus && queueError && queueError.length) {
                    queueTransactionStatus = API_TRANSACTION_STATUS_ERROR
                }

                // determine what to do by analyzing the status of response
                switch (queueTransactionStatus) {
                    case API_TRANSACTION_STATUS_WAIT: {
                        // do nothing, just wait and let the timer to call again the checking
                        console.log("WAITING for multi step transaction, status = ", queueTransactionStatus)
                        console.log("WAITING for multi step transaction, statusId = ", queueTransactionId)
                        return response
                        break
                    }
                    case API_TRANSACTION_STATUS_ERROR: {
                        // clear timer for rechecking
                        clearInterval(timerIdForCheckResponse)
                        timerIdForCheckResponse = false

                        // stop spinner
                        // dispatch(hideLoader(uri))

                        return rejectTransaction(response)
                        break
                    }
                    case API_TRANSACTION_STATUS_DONE: {
                        console.log("queueTransactionStatus ", API_TRANSACTION_STATUS_DONE)
                        // clear timer for rechecking
                        clearInterval(timerIdForCheckResponse)
                        timerIdForCheckResponse = false

                        // fetch the final valuable data
                        let resultData = nesProp.get(response, "data")

                        // stop spinner
                        // dispatch(hideLoader(uri))

                        // simplify the response
                        return resolveTransaction(resultData)
                        break
                    }
                    // this case when the multi step transaction technology is not implemented on the server
                    // in this case this wrapper behave like a normal apiCall,
                    // so let the outer algorith to do, what they want with the response
                    default: {
                        // clear timer for rechecking
                        clearInterval(timerIdForCheckResponse)
                        timerIdForCheckResponse = false

                        // stop spinner
                        // dispatch(hideLoader(uri))

                        return resolveTransaction(response)
                        break
                    }
                }
            // --- end api call block
            })
            .catch((err) => {

                // stop spinner
                // dispatch(hideLoader(uri))
                return rejectTransaction(err)
            })
        // --- end of timer block
        }, API_TRANSACTION_CHECK_INTERVAL_SEC * 1000)

    // --- end of master transaction promise
    })
    .then((result) => {
        // stop spinner
        dispatch(hideLoader(0))
        //dispatch(forceSetLoader(0))
        return result
    })
    .catch((err) => {
        // stop spinner
        dispatch(hideLoader(0))
        //dispatch(forceSetLoader(0))
        return err
    })


    return transactionPromise
}



// WEBPACK FOOTER //
// ./state/actions/api.js